import { Injectable } from '@angular/core';
declare var $: any;

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class LoaderService {

  constructor() { }

  showLoader() {
    $('body').addClass('loading').loader('show', { overlay: true });
  }

  hideLoader() {
    $('body').removeClass('loading').loader('hide');
  }
}
